<template>
  <v-container>
    <v-card flat tile>
      <template v-if="!loading">
        <v-data-table
          dense
          :headers="headers"
          :items="items"
          item-key="name"
          group-by="useCaseName"
          show-group-by
          class="elevation-1"
          :disable-pagination="disablePagination"
          :hide-default-footer="disablePagination"
          show-group-b
        ></v-data-table>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import httpClient from '@/api/httpClient'

export default {
  data() {
    return {
      title: 'Use case docs page',
      headers: [
        { text: 'id', value: 'id' },
        {
          text: 'Name',
          align: 'start',
          value: 'name'
        },
        { text: 'Description', value: 'description' }
      ],
      loading: null,
      items: [],
      disablePagination: true
    }
  },
  beforeMount() {},
  created() {
    httpClient
      .get('usecasedocs')
      .then(response => this.groupItems(response.data))
  },
  updated() {},
  methods: {
    groupItems(items) {
      const groupItems = []
      for (const item of items) {
        for (const useCase of item.useCases) {
          Object.defineProperty(useCase, 'useCaseName', {
            value: item.name,
            writable: false
          })
          groupItems.push(useCase)
        }
      }
      this.items = groupItems
      this.loading = false
    }
  }
}
</script>
